import MyPath from "./MyPath";

export default MyPath;
